import { textDateFormats, useGenericPatchParser } from '#record/parser';
import { PriorTrxAuthzJsonSerialization } from '#trxauth.prior/jsonserializer';
import { PriorTrxAuthPatch } from '#trxauth.prior/model';
import { DeepPartial, utils } from 'apprise-core/utils';
import { useT } from 'apprise-frontend-core/intl/language';
import { ParsePostProcessor, ResourceParseOutcome } from 'apprise-frontend-parse/model';
import { useDefaultModelParser, useDefaultParser } from 'apprise-frontend-parse/resource';
import { useParseUtils } from 'apprise-frontend-parse/utils';
import { useDefaultBookParser } from 'apprise-frontend-parse/workbook';
import { priorTrxauthzType } from './constants';




export const usePriorTrxAuthzParser = () => {

  const modelparser = useDefaultModelParser(usePriorTrxAuthzRowParser())

  const bookparser = useDefaultBookParser(modelparser, priorTrxauthzType)


  const postProcess: ParsePostProcessor<PriorTrxAuthPatch> = (outcome: ResourceParseOutcome<PriorTrxAuthPatch>) => {

    const mergePatches = (patches: PriorTrxAuthPatch[]) => {

      const reduced = patches.reduce((merged, patch) => {

        // bootstrap accumulation
        if (!merged[priorTrxauthzType])
          return patch

        let reduced = merged
        let control = patch

        reduced[priorTrxauthzType].authzs.push(...control[priorTrxauthzType].authzs)

        return reduced

      }, {} as PriorTrxAuthPatch)

      reduced[priorTrxauthzType].authzs.sort((a, b) => (b.to ?? '').localeCompare(a.to ?? ''))

      return reduced
    }

    const grouped = Object.values(utils().index(outcome.data).byGroup(patch => patch.uvi ?? utils().mint('new'))).map(mergePatches)
   
    return {

      ...outcome,

      data: grouped

    }

  }

  return useDefaultParser({ modelparser, bookparser, postProcess })


}


export const usePriorTrxAuthzRowParser = () => {

  const t = useT()
  const parse = useParseUtils()



  const parser = (row: PriorTrxAuthzJsonSerialization) => {

    const patch: DeepPartial<PriorTrxAuthPatch> = {

      scope: 'rav',
      cmm: '25/05',

      patchedSlots: [priorTrxauthzType],

      [priorTrxauthzType]: {

        timestamp: undefined!,

        id: utils().mint('PTRX'),

        authzs: [{

          timestamp: undefined!,
          from: parse.date(row.from, textDateFormats).orIssue('error').about(t('trxauthz.from')).on(row.uvi ?? t('rec.no_identifier')),
          to: parse.date(row.to).orIssue('error').about(t('trxauthz.to')).on(row.uvi ?? t('rec.no_identifier')),
          authorisationNumber: row.number?.trim() || undefined,
          authorisingEntity: row.entity?.trim() || undefined

        }]
      }
    }

    return patch as PriorTrxAuthPatch
  }

  return useGenericPatchParser(parser)

}